import { LinearProgressBar } from './styles';

export default LinearProgressBar;
